import { apiRoute } from "../utils";
import { BaseRequest } from "./Request";

export const getFlag = async () => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/flags`);
  const response = (await baseRequest.get(url)) as any;
  return await response.json();
};

export const updatKycStatus = async (data: any, id: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/flags/${id}`);
  const response = (await baseRequest.patch(url, data)) as any;
  return await response?.json();
};

export const updateSolanaStatus = async (
  tiers: { name: any; value: boolean },
  Id: number
) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/flags/${Id}`);
  const response = (await baseRequest.patch(url, tiers)) as any;
  return await response?.json();
};

export const getForbiddenCountries = async () => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/configs`);
  const response = (await baseRequest.get(url)) as any;
  return await response.json();
};

export const updateForbiddenCountries = async (data: any, id: any) => {
  const baseRequest = new BaseRequest();
  let url = apiRoute(`/configs/${id}`);
  const response = (await baseRequest.patch(url, data)) as any;
  return await response?.json();
};